import React from 'react';
import Image from 'next/image';
import Cta from './Cta';
import usePrefix from '@/hooks/usePrefix';
import { CDN2 } from '@/helpers/api';
export interface IFeatures {
  full?: boolean;
  top?: boolean;
  showCtaButton?: boolean;
  hiddenOnMobile?: boolean;
}

export default function Features({
  full,
  top,
  showCtaButton = true,
  hiddenOnMobile = false,
}: IFeatures) {
  const prefix = usePrefix();
  return (
    <div
      className={`${full ? 'bg-orange-50' : ''} ${
        hiddenOnMobile ? 'hidden md:block' : ''
      }`}
    >
      <div className="container px-4 mx-auto">
        <div
          className={`${
            full ? '' : 'shadow-sm'
          } rounded-md flex flex-col p-8 my-12 mx-2 bg-orange-50 h-full`}
        >
          <h2 className="text-center text-3xl mt-4 mb-12">
            Why On Air Parking?
          </h2>
          <div
            className={`grid grid-cols-1 md:grid-cols-4 gap-8 place-items-start ${
              !showCtaButton ? 'mb-6' : ''
            }`}
          >
            <div className="flex flex-col items-center">
              <Image
                quality={65}
                src={CDN2() + '/staticmyapp/icon-quality.svg'}
                blurDataURL={CDN2() + '/staticmyapp/icon-quality.svg'}
                alt="Quality"
                width={50}
                height={50}
              />
              <h3 className="text-lg text-center my-4">Quality</h3>
              <p className="text-center">
                We exclusively choose only the best airport parking providers.
                Shuttle service to and from the airport and a guaranteed parking
                space.
              </p>
            </div>
            <div className="flex flex-col items-center">
              <Image
                quality={65}
                src={CDN2() + '/staticmyapp/icon-price.svg'}
                blurDataURL={CDN2() + '/staticmyapp/icon-price.svg'}
                alt="Quality"
                width={50}
                height={50}
              />
              <h3 className="text-lg text-center my-4">Lowest Price</h3>
              <p className="text-center">
                We guarantee the lowest price you'll find online. Book through a
                membership and pay no extra fees.
              </p>
            </div>
            <div className="flex flex-col items-center">
              <Image
                quality={65}
                src={CDN2() + '/staticmyapp/icon-travel.svg'}
                blurDataURL={CDN2() + '/staticmyapp/icon-travel.svg'}
                alt="Quality"
                width={50}
                height={50}
              />
              <h3 className="text-lg text-center my-4">Reservations Support</h3>
              <p className="text-center">
                Our Parking Reservation Specialists are at your service from
                10am to 7pm ET, Monday through Friday. After hours feel free to
                text (424-532-8940) and a Reservation Specialist will respond
                the next day.
              </p>
            </div>
            <div className="flex flex-col items-center">
              <Image
                quality={65}
                src={CDN2() + '/staticmyapp/icon-guarantee.svg'}
                alt="Quality"
                width={50}
                height={50}
                blurDataURL={CDN2() + '/staticmyapp/icon-guarantee.svg'}
              />
              <h3 className="text-lg text-center my-4">Guarantee</h3>
              <p className="text-center">
                We guarantee everything we sell: the quality, price, and
                service. We will meet all of your A+ expectations.
              </p>
            </div>
          </div>
          {showCtaButton &&
            (top ? (
              <Cta
                url={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                marginTop={12}
              />
            ) : (
              <Cta url={prefix + '/'} marginTop={12} />
            ))}
        </div>
      </div>
    </div>
  );
}
